module.exports = __webpack_public_path__ + "img/brightness-alt-high-fill.ca4ab1fa.svg";